// extracted by mini-css-extract-plugin
module.exports = {"warningModal":"upload-image_warningModal_qJB7t","textarea":"upload-image_textarea_WRosz","Upload":"upload-image_Upload_1Pjd8"};